import { useInstallerStatus } from "@/hooks/useInstallerStatus";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import LandingPage from "@/pages/LandingPage";

const Index = () => {
  const { installed, loading } = useInstallerStatus();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (installed === false) {
    return <Navigate to="/app-status" replace />;
  }

  return <LandingPage />;
};

export default Index;
